<template>
    <div class="elle-play">
        <button type="button" class="elle-play-btn" data-is-btn :aria-label="playLabel" @click="onClick">
            <span class="icon">
                <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.2002 7.72811L0.200195 14.6563V0.799909L12.2002 7.72811Z" fill="currentColor" />
                </svg>
            </span>
            <span class="text">{{ playLabel }}</span>
        </button>
        <ClientOnly>
            <Teleport to="#elle-main">
                <ModalsVideo :poster="poster[0]" :video="video[0]" />
            </Teleport>
        </ClientOnly>
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const emit = defineEmits(['btn-click']);
const props = withDefaults(
    defineProps<{
        poster?: CmsItem[];
        video?: CmsItem[];
        label?: string;
    }>(),
    {
        poster: () => [],
        video: () => [],
        label: ''
    }
);

const { t } = useI18n();

const poster = computed(() => props.poster);
const video = computed(() => props.video);
const playLabel = computed(() => props.label?.trim() || t('site.label_watch_video'));

const showModal = useShowModal();
const onClick = () => {
    showModal.value = true;
    emit('btn-click');
};
</script>
